import { useAuth0 } from "@auth0/auth0-react";
import {
  Button,
  Container,
  Typography,
  CircularProgress,
  Box,
  Paper,
} from "@mui/material";
import { Navigate, useLocation } from "react-router-dom";

const Login = () => {
  const { loginWithRedirect, isAuthenticated, isLoading } = useAuth0();
  const location = useLocation();

  // Remember where the user wanted to go
  const from = location.state?.from?.pathname || "/dashboard";

  if (isLoading) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" height="100vh">
        <CircularProgress />
      </Box>
    );
  }

  // Redirect authenticated users to intended page
  if (isAuthenticated) {
    return <Navigate to={from} replace />;
  }

  return (
    <Container maxWidth="xs" sx={{ display: "flex", justifyContent: "center", mt: 10 }}>
      <Paper elevation={3} sx={{ p: 4, textAlign: "center", width: "100%" }}>
        <Typography variant="h5" gutterBottom>
          Admin Portal
        </Typography>

        <Button
          variant="contained"
          color="primary"
          fullWidth
          sx={{ mt: 2 }}
          onClick={() => loginWithRedirect({ appState: { returnTo: from } })}
          aria-label="Log in to admin portal"
        >
          Log In
        </Button>
      </Paper>
    </Container>
  );
};

export default Login;
